import React, {useState} from 'react';

import {useUserContext} from "../../../contexts/UserContext";
import {CreateClientItem} from "./CreateClientItem";
import {useDebounce} from "@uidotdev/usehooks";
import useDidMountEffect from "../../../hooks/useDidMountEffect";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Tooltip from "@mui/material/Tooltip";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import {ConfirmationModal} from "../../../components/ConfirmationModal";
import {NewColumnModal} from "../NewColumnModal";
import {useModalsStore} from "../../../stores/modalsStore";

export const CustomClientColumnHeader = ({ column, columnID }) => {
    const { profileState, setProfileStateWithUpdate } = useUserContext()
    const openModal = useModalsStore((state) => state.openModal)
    const [columnName, setColumnName] = useState(column['display_name'])
    const debouncedColumn = useDebounce(columnName, 300)

    useDidMountEffect(function updateLeadColumnHeader() {
        const newClientColumns = structuredClone(profileState.client_columns)
        newClientColumns[columnID]["display_name"] = columnName

        setProfileStateWithUpdate({...profileState, client_columns: newClientColumns})
    }, [debouncedColumn])

    const deleteColumn = () => {
        const newLeadColumns = structuredClone(profileState.client_columns)
        delete newLeadColumns[columnID]
        setProfileStateWithUpdate({...profileState, client_columns: newLeadColumns})
    }

    const description = `Are you sure you want to delete column ${columnName}? \n Deleting
    this column will also delete all the associated data.`

    const numberOfColumns = Object.keys(profileState.client_columns).length

    const colWidth = 20 / numberOfColumns


    return (
        <th
            key={columnID}
            width={`${colWidth}%`}
            className={'crm_table_header custom-column'}
        >
            <input
                className=""
                type="text"
                value={columnName}
                onChange={(e) => setColumnName(e.target.value)}
            />
            <Tooltip title="Delete Column" arrow placement={'top'}>
                <DeleteForeverIcon onClick={() => {
                    openModal({
                        element: ConfirmationModal,
                        id: "ConfirmationModal",
                        props: {
                            onConfirm: deleteColumn,
                            header: `Delete column "${columnName}"`,
                            description: description,
                        }
                    })
                }}/>
            </Tooltip>
        </th>
    )

}


export const ClientsTableHeaders = ({profit}) => {
    const openModal = useModalsStore((state) => state.openModal)
    const { profileState, setProfileStateWithUpdate } = useUserContext()
    const columns = profileState.client_columns
    const client_columns = profileState.client_columns

    const addColumn = (name) => {
        let highestOrderNum = 0
        Object.values(columns).map(col => {
            if (col.order > highestOrderNum) {
                highestOrderNum = col.order
            }
        })
        const newId = new Date().getTime()
        const newOrderNum = highestOrderNum + 1
        const newColumn = {
            order: newOrderNum,
            name: name,
            display_name: name
        }

        setProfileStateWithUpdate(
            {
                ...profileState,
                client_columns: {...client_columns, [newId]: newColumn}
            }
        )
    }

    const sortedColumns = Object.keys(columns).sort((a, b) => columns[a] - columns[b])

    return (
        <thead>
        <tr className={"clients_table_row"}>
            <th
                width={'5%'}
                key='Name' className={'crm_table_header'}>
                Name
            </th>

            <th
                width={'3%'}
                key='Phone' className={'crm_table_header'}>
                Phone
            </th>
            <th
                width={'5%'}
                key='Email' className={'crm_table_header'}>
                Email
            </th>
            <th key='Vehicle' width={'5%'} className={'crm_table_header'}>
                Vehicle
            </th>
            <th
                width={'5%'}
                key='Profit' className={'crm_table_header'}>
                <span>Profit ({profit.toDollarFormat()})</span>
            </th>
            <th
                width={'1%'}
                key='Inception Date' className={'crm_table_header'}>
                Inception
            </th>
            <th
                width={'1%'}
                key='Maturity Date' className={'crm_table_header'}>
                Maturity
            </th>
            {
                sortedColumns.map((columnID) => (
                        <CustomClientColumnHeader
                            key={columnID}
                            column={columns[columnID]}
                            columnID={columnID}/>
                    )
                )
            }

            <th
                width={'1%'}
                key='Actions'
                className={'crm_table_header actions'}
            >
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    className={''}
                    style={{
                        height: '100%'
                    }}
                >
                    <span>Actions</span>

                    <Tooltip title="Add Column" arrow placement={'top'}>
                        <th
                            onClick={() => {
                                openModal({
                                    element: NewColumnModal,
                                    id: "NewColumnModal",
                                    props: {
                                        onSave: (name) => addColumn(name),
                                        columns: columns
                                    }
                                })
                            }}
                            className={'add-column'}
                        >
                            <AddIcon/>
                        </th>
                    </Tooltip>
                </Stack>
            </th>

        </tr>
        <CreateClientItem/>
        </thead>
    )
}